import { Injectable } from '@angular/core';

import { downloadZipReport, get, post } from '@core/interceptors/fetch-client';
import { ApiUtils } from '@core/services/Utils/apiUtils';
import { environment } from '@home/src/app/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CustomReportService {
  async getGroupComposites(
    apiUrl: string,
  ): Promise<{ statusCode: number; data: any }> {
    let response: { statusCode: number; data: any } | null = null;

    try {
      await ApiUtils.handleApiResponse1(
        get<any>(apiUrl, {}, true),
        (data, statusCode) => {
          response = {
            statusCode,
            data,
          };
        },
        'Failed to fetch composite table details Data:',
      );

      return response as unknown as { statusCode: number; data: any };
    } catch (error) {
      console.error('Failed to fetch composite table details Data', error);
      throw error;
    }
  }
  async groupCompositeExport(url: string, data: any): Promise<any> {
    try {
      const response = await post<any>(url, data, {}, true);
      return response.parsedBody;
    } catch (error) {
      console.error('Error submitting specification:', error);
      throw error;
    }
  }
  async getReportLink(queueId: string): Promise<void> {
    const qid = Number(queueId);
    const isLocalhost = window.location.hostname === 'localhost';
    const url = environment.GetCompositeGenerationZip;
    let targetUrl = url;
    if (isLocalhost) {
      targetUrl += `?code=${environment.functionappCode}`;
    }

    try {
      await downloadZipReport(targetUrl, qid, true);
    } catch (error) {
      console.error('Download error:', error);
    }
  }
}
